export default [
    // {
    //     title: 'Dashboard',
    //     route: 'pages-dashboard',
    //     icon: 'HomeIcon',
    // },
]
